/**
 * Web video upload has been retired — every route now lands here.
 *
 * Uploads moved to the HG Media iPad app, which handles background uploads and
 * retries that the browser version could not. Nothing in this page talks to the
 * API, so it keeps working regardless of backend or auth changes.
 */

import React from 'react';
import { Box, Typography, Button, Paper, Stack } from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

const APP_STORE_URL = 'https://apps.apple.com/us/app/hg-media/id6761889172';

const AppMoved = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: 2,
      py: 6,
      backgroundColor: 'background.default',
    }}
  >
    <Paper
      elevation={0}
      sx={{
        maxWidth: 460,
        width: '100%',
        p: { xs: 3, sm: 5 },
        textAlign: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/homeguard-logo.png`}
        alt="HomeGuard"
        sx={{ height: 64, width: 'auto', mb: 3 }}
      />

      <Typography variant="h5" component="h1" sx={{ fontWeight: 700, mb: 1.5 }}>
        Video uploads have moved
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 1.5 }}>
        Uploading videos from the browser is no longer supported. Please use the
        <strong> HG Media </strong> app on your iPad instead.
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        The app uploads in the background, so you can close it or lose signal
        without losing your videos.
      </Typography>

      <Stack spacing={1.5}>
        <Button
          variant="contained"
          size="large"
          fullWidth
          startIcon={<PhoneIphoneIcon />}
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ py: 1.4, fontWeight: 600, textTransform: 'none', fontSize: '1rem' }}
        >
          Get the HG Media app
        </Button>

        <Typography variant="caption" color="text.secondary">
          Already installed? Open HG Media on your iPad to upload.
        </Typography>
      </Stack>
    </Paper>
  </Box>
);

export default AppMoved;
